import type { BoardModelDebugLabelPlacement } from "./labelPlacement";
import type { Bounds } from "./bounds";

/** Matches debug frame border width in CSS. */
export const BOARD_MODEL_DEBUG_BORDER_PX = 2;

export function positionBoardModelDebugLabel(
  label: HTMLElement,
  box: Bounds,
  placement: BoardModelDebugLabelPlacement,
): void {
  const inset = BOARD_MODEL_DEBUG_BORDER_PX;
  const { minX, minY, maxX, maxY } = box;
  const midX = (minX + maxX) / 2;
  switch (placement) {
    case "top-left":
      label.style.transform = `translate(${minX + inset}px, ${minY + inset}px)`;
      break;
    case "top-center":
      label.style.transform =
        `translate(${midX}px, ${minY + inset}px) translate(-50%, 0)`;
      break;
    case "top-right":
      label.style.transform =
        `translate(${maxX - inset}px, ${minY + inset}px) translate(-100%, 0)`;
      break;
    case "bottom-left":
      label.style.transform =
        `translate(${minX + inset}px, ${maxY - inset}px) translate(0, -100%)`;
      break;
    case "bottom-center":
      label.style.transform =
        `translate(${midX}px, ${maxY - inset}px) translate(-50%, -100%)`;
      break;
    case "bottom-right":
      label.style.transform =
        `translate(${maxX - inset}px, ${maxY - inset}px) translate(-100%, -100%)`;
      break;
  }
}
